<template>
  <BoxOutSharesTable />
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxOutSharesTable from '@/components/deepbox/box/BoxOutSharesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.box.out_shares',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
